export default __webpack_public_path__ + "static/media/icon-admin-white.968ece00.svg";